import Header from './header';
import Footer from './footer';
import { Outlet, Link } from "react-router-dom";

function Denied() {
    return (
        <>
            <Header active="Agenda"></Header>
            <h1>No tienes permiso para agendar</h1>
            <Link to="/"><button className='volverIndex'>Volver</button></Link>
            <Footer></Footer>
        </>
    )
}

export default Denied;